// extracted by mini-css-extract-plugin
export default {"primary":"#0b0950","dark":"#3e4042","aqua":"#7bb3b2","red":"#ff8b8b","blue":"#7bb3b2","light-blue":"#70b4ed","yellow":"#ffd100","button":"appbutton_button__BjCo3"};